import React, { Component } from 'react';
import { request } from 'graphql-request'
import html2pdf from 'html2pdf.js';
import { GoogleLogin, GoogleLogout} from 'react-google-login';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import Reports from './Reports';
import './App.css';
import logo from './logo.png';

const INPUT_REGEX = /^[0-9]{0,12}$/;
const INPUT_ERROR = 'Input should include digits only';
const NO_RESULTS = 'No results for this date range';
const AUTHORIZED_USERS = ['ron@healthy.io', 'lilach@healthy.io', 'michael@healthy.io', 'yosef@healthy.io','avigail.friedland@healthy.io'];
const CLIENT_ID = '210949277320-19g7dedjit8l3agi897bkavjm7cd0vur.apps.googleusercontent.com';
const BACKEND_URL = 'https://spot-research-lab.healthy.io/graphql';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            patientId: '',
            reportFields: null,
            scans: [],
            inputError: null,
            signedIn: false,
            startDate: moment(new Date()).add(-1, 'days'),
            endDate: moment(new Date()),
            noResults: false
        };
    }

    render() {
        return (
          <div className="App">
            <header className="App-header">
              <img src={logo} className="App-logo" alt="logo" />
              <div className="App-title">SPOT Source Docs</div>
                {this.state.signedIn ? (
                <GoogleLogout
                  buttonText="Logout"
                  onLogoutSuccess={this._handleSignOutClick}
                  className="login-button"/>
              ) : (
                <GoogleLogin
                    clientId={CLIENT_ID}
                    buttonText="Login"
                    onSuccess={this._handleSignInClick}
                    onFailure={this._handleSignInError}
                    className="login-button"/>
                )}
            </header>
              {(this.state.signedIn) && <div>
                  <div className="App-body">
                    <form onSubmit={this._handleSubmit} className="App-form">
                        <div className="Dates-wrapper">
                            <div>Start Date:
                            <label>
                              <DatePicker
                              dateFormat="DD/MM/YYYY"
                                className="App-input"
                                selected={this.state.startDate}
                                onChange={this._handleStartDateChange}/>
                            </label>
                                </div>
                            <div>End Date:
                            <label>
                              <DatePicker
                              dateFormat="DD/MM/YYYY"
                                className="App-input"
                                selected={this.state.endDate}
                                onChange={this._handleEndDateChange}/>
                              </label>
                                </div>
                            <div>Patient token (optional):
                            <label>
                                <div>
                              <input type="text" value={this.state.patientId} onChange={this._handleChange} className="App-input"/>
                                <div className="error-message">{this.state.inputError}</div>
                                    </div>
                            </label>
                             </div>
                        </div>
                        <div className="App-submit-wrapper" align="right">
                            <input type="submit" value="Submit" align="left" className="submit-button"/>
                        </div>

                  </form>


                </div>
              {(this.state.scans.length !== 0) && <Reports scans={this.state.scans}/>}
              {this.state.noResults && <div className="App-no-results">{NO_RESULTS}</div>}
            </div>}
          </div>
            );
    }

    _handleChange = (e) => {
        if(INPUT_REGEX.test(e.target.value))
            this.setState({
                patientId: e.target.value,
                inputError: null
            });
        else
            this.setState({ inputError: INPUT_ERROR });
    };

    _handleStartDateChange = (day) => {
        this.setState({startDate: moment(day).startOf('day')});

    };

    _handleEndDateChange = (day) => {
        this.setState({endDate: moment(day).endOf('day')});
    };

    _handleSubmit = (e) => {
        e.preventDefault();
        const gql_query = this._getGglQuery();
        request(BACKEND_URL, gql_query)
            .then(response => {
                if (response.scans.length > 0) {
                    this.setState({scans: response.scans});
                    setTimeout(() => {this._printReportToPdf();}, 1000);
                }
                else
                    this.setState({ noResults: true });
        })
        .catch(error => console.log(error));
    };

    _handleSignOutClick = () => this.setState({signedIn: false});

    _handleSignInClick = (response) => {
        if (AUTHORIZED_USERS.includes(response.profileObj.email))
            this.setState({signedIn: true});
        else {
            alert('User not authorized');
            this._handleSignOutClick();
        }
    };

    _handleSignInError = () => console.log('Failed to login');

    _getGglQuery() {
        const patient_token = this.state.patientId === '' ? '' : `patient_token: "${this.state.patientId}"`;
        return `query Scans {
                                scans( start_date: ${this.state.startDate.unix()}, end_date: ${this.state.endDate.unix()},`+ patient_token + `) {
                                    timestamp,
                                    anamnesis { patient_token, gender, year_of_birth, background_diseases, temperature, 
                                                wound_location { ﻿orientation, side,﻿organ,﻿area }, number_of_wounds, wound_appearance_date, 
                                                wound_treatment_date, wound_type, offensive_smell, pain_level, secretion_amount, secretion_characteristics, 
                                                peripheral_pulse, edema, secondary_infection, temperature, wound_length, wound_width, wound_depth, 
                                                tissues_segmentation { fibrin, granulated_undamaged, granulated_damaged, slough, necrotic, deep_tissues }, 
                                                edges, pass_treatment }
                                    tags { operator, clinician }
                                }
                            }`;
    }

    _printReportToPdf = () => {
        const element = document.getElementById('reports-wrapper');
        const fileName = 'spot_source_docs.pdf';
        html2pdf(element, {
            margin: 15,
            filename: fileName
        });
    };
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx